export enum LockDataType {
  TIME_ATTENDANCE = "TIME_ATTENDANCE",
  OT = "OT",
  LEAVE = "LEAVE",
  PAYROLL = "PAYROLL",
  TA_LEAVE = "TA_AND_LEAVE",
}

export enum LockDataAction {
  LOCK = "LOCK",
  UNLOCK = "UNLOCK",
}
